class CountdownTimer extends HTMLElement {
	constructor() {
		super();
		this.timerDisplay = null;
		this.storeTimezone = this.getAttribute('data-timezone') || 'America/New_York';
		this.endTime = this.parseEndTime(this.getAttribute('data-time'));
	}

	connectedCallback() {
		if (!this.endTime || this.getCurrentTimeInStoreTimezone() >= this.endTime) {
			this.remove();
			return;
		}

		this.timerDisplay = document.createElement('span');
		this.timerDisplay.className = 'announcement-bar__countdown';
		this.timerDisplay.setAttribute('aria-live', 'off');
		this.appendChild(this.timerDisplay);

		this.updateCountdown();
		this.interval = setInterval(() => this.updateCountdown(), 1000);
	}

	disconnectedCallback() {
		clearInterval(this.interval);
		if (this.timerDisplay && this.timerDisplay.parentNode === this) {
			this.removeChild(this.timerDisplay);
		}
	}

	parseEndTime(endTimeString) {
		if (!endTimeString) return null;

		// Prefer YYYY-MM-DD HH:MM:SS (or HH:MM) parsed as store-local wall time
		const match = String(endTimeString)
			.trim()
			.match(/^(\d{4})-(\d{2})-(\d{2})(?:[ T](\d{2}):(\d{2})(?::(\d{2}))?)?$/);

		if (match) {
			const [, year, month, day, hour = '0', minute = '0', second = '0'] = match;
			const asUTC = Date.UTC(
				Number(year),
				Number(month) - 1,
				Number(day),
				Number(hour),
				Number(minute),
				Number(second)
			);
			const offsetMs = this.getTimeZoneOffsetMs(asUTC, this.storeTimezone);
			return new Date(asUTC - offsetMs);
		}

		const parsed = new Date(endTimeString);
		return Number.isNaN(parsed.getTime()) ? null : parsed;
	}

	getTimeZoneOffsetMs(utcMillis, timeZone) {
		try {
			const formatter = new Intl.DateTimeFormat('en-US', {
				timeZone,
				year: 'numeric',
				month: '2-digit',
				day: '2-digit',
				hour: '2-digit',
				minute: '2-digit',
				second: '2-digit',
				hour12: false,
			});
			const parts = formatter.formatToParts(new Date(utcMillis));
			const values = Object.fromEntries(parts.filter((part) => part.type !== 'literal').map((part) => [part.type, part.value]));
			const asIfUTC = Date.UTC(
				Number(values.year),
				Number(values.month) - 1,
				Number(values.day),
				Number(values.hour === '24' ? '0' : values.hour),
				Number(values.minute),
				Number(values.second)
			);
			return asIfUTC - utcMillis;
		} catch (error) {
			console.warn('Error reading store timezone offset:', error);
			return 0;
		}
	}

	getCurrentTimeInStoreTimezone() {
		return new Date();
	}

	updateCountdown() {
		if (!this.timerDisplay || !this.endTime) return;

		const timeRemaining = this.endTime - this.getCurrentTimeInStoreTimezone();

		if (timeRemaining <= 0) {
			clearInterval(this.interval);
			this.remove();
			return;
		}

		const days = Math.floor(timeRemaining / (1000 * 60 * 60 * 24));
		const hours = Math.floor((timeRemaining % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
		const minutes = Math.floor((timeRemaining % (1000 * 60 * 60)) / (1000 * 60));
		const seconds = Math.floor((timeRemaining % (1000 * 60)) / 1000);

		this.timerDisplay.innerHTML = `
      <span class="announcement-bar__countdown-value">${days}</span><span class="announcement-bar__countdown-unit">d</span>
      <span class="announcement-bar__countdown-value">${hours}</span><span class="announcement-bar__countdown-unit">h</span>
      <span class="announcement-bar__countdown-value">${minutes}</span><span class="announcement-bar__countdown-unit">m</span>
      <span class="announcement-bar__countdown-value">${seconds}</span><span class="announcement-bar__countdown-unit">s</span>
    `;
	}
}

if (!customElements.get('countdown-timer')) {
	customElements.define('countdown-timer', CountdownTimer);
}
